import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { NoSSR } from '@hbf/dsl';
import { ImageGridSkeleton } from 'ha/components/ImageGrid/ImageGridSkeleton';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { CELL_HEIGHT } from 'ha/components/ImageGrid/constants';

import { ListingMapContainer as ListingMap } from '../containers/ListingMap';

const useStyles = makeStyles()(theme => ({
  container: {
    position: 'relative',
    height: `${CELL_HEIGHT.Mobile * 2}px`,
    [theme.breakpoints.up('md')]: {
      height: `${CELL_HEIGHT.Desktop * 2}px`,
    },
  },
}));

export const MapSection: React.FC = () => {
  const { md } = useMediaQuery();
  const { classes } = useStyles();

  return (
    <div className={classes.container} data-test-locator="Map section">
      <NoSSR fallback={<ImageGridSkeleton numPhotos={1} />}>
        {md ? (
          <ListingMap />
        ) : (
          <ListingMap dragging={false} zoomControl={false} fullscreenButton />
        )}
      </NoSSR>
    </div>
  );
};
